export default __webpack_public_path__ + "static/media/dashboard.090252b6.jpg";